export const ARTWORKS_GRID_TEST_ID = 'artworks_grid_test_id';

export const ANIMATION_DURATION = 500;

export enum ARTWORK_POSITION_TYPE {
  ABSOLUTE = 'absolute',
  RELATIVE = 'relative',
}
